'use client'

// Error boundary global do App Router — captura erros não-tratados de render
// no client via a abstração `captureClient` de @v2/monitor (não usa o SDK direto).
import { captureClient } from '@v2/monitor/providers/sentry-init'
import { useEffect } from 'react'

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string }
}) {
  useEffect(() => {
    captureClient(error, { tags: { area: 'global-error' } })
  }, [error])

  return (
    <html lang="pt-BR">
      <body
        style={{
          fontFamily: 'system-ui, sans-serif',
          display: 'flex',
          minHeight: '100vh',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2rem',
          textAlign: 'center',
          color: '#0f172a',
        }}
      >
        <div>
          <h2 style={{ fontSize: '1.125rem', fontWeight: 600 }}>
            Algo deu errado
          </h2>
          <p style={{ marginTop: '0.5rem', fontSize: '0.875rem', color: '#64748b' }}>
            O erro foi registrado. Recarregue a página ou tente novamente.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              marginTop: '1rem',
              padding: '0.5rem 1rem',
              fontSize: '0.875rem',
              borderRadius: '0.375rem',
              background: '#0f172a',
              color: '#fff',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Recarregar
          </button>
        </div>
      </body>
    </html>
  )
}
